import React from 'react';
import CardPromo from '../../molecules/CardPromo';
import { FiArrowRight } from 'react-icons/fi';
import { convertStringToSlug, triggerNativeMessage } from '../../../helpers/utils';
import useIsNativeView from '../../../hooks/useIsNativeView';
import { useSearchParams } from 'next/navigation';
import eventClickDetailBranchSales from '../../../helpers/emarsys/branch-sales/eventClickDetailBranchSales';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { FEATURE, PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import { Province } from '../../../interface';

interface Props {
  data: any;
  title?: string;
  description?: string;
  baseUrl?: string;
  hideAllPromotionButton?: boolean;
  breadcrumbItems?: IBreadcrumbs[];
  branchProvince?: Province;
  pageTitle?: string;
  city?: string;
  cityCode?: string;
  feature?: string;
}

const PromoEventSection = ({
  data = [],
  title = '',
  description = '',
  baseUrl = '',
  hideAllPromotionButton = false,
  breadcrumbItems = [],
  branchProvince,
  pageTitle = '',
  city = '',
  cityCode = '',
  feature = '',
}: Props) => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };
  const searchParams = useSearchParams();
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  const isNativeView = useIsNativeView();

  const handleGoToPromoBranchList = (e, branch) => {
    if (isNativeView) {
      e.preventDefault();
    }
    if (feature === FEATURE.BRANCH_LISTING_PAGE) {
      eventClickSeeAllEmarsys();
    }
    const branchSlug = branch?.[0]?.branch?.branchLandingPage?.seoSlug || null;
    triggerNativeMessage('goToPromoBranchList', { branchSlug });
  };

  const handleGoToPromoBranchDetail = (e, message, data) => {
    if (isNativeView) {
      e.preventDefault();
    }

    const cityCode = searchParams.get('area');
    const branchCode = data?.branch?.branchLandingPage?.seoSlug || null;
    const contentCategory = data?.contentCategory?.name || null;
    const slug = data?.slug || null;

    const params = {
      citySlug: cityCode,
      branchSlug: branchCode,
      contentCategory: convertStringToSlug(contentCategory),
      slug: slug,
    };

    triggerNativeMessage(message, params);
  };

  const eventClickSeeAllEmarsys = () => {
    eventClickDetailBranchSales({
      dispatch,
      customerNo: userData?.customerNo,
      breadcrumbItems: breadcrumbItems,
      pageName: PAGE_NAME_BRANCH_SALES.LIST_DEALER_TOYOTA,
      pageTitle: pageTitle,
      sectionName: 'promo bengkel',
      buttonName: 'lihat semua',
      newParams: {
        province: branchProvince?.name ?? '',
        province_code: branchProvince?.isocode ?? '',
        city: city,
        city_code: cityCode,
        ...(breadcrumbItems?.[2]?.name
          ? {
              menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase(),
            }
          : {}),
      },
    });
  };

  return (
    <section className="my-5 lg:my-8 container px-0" data-testid="city-promo-landing">
      <div className="flex justify-between lg:items-center gap-2 px-4 lg:px-0">
        <div>
          <h2 className="text-base font-bold uppercase text-reliableBlack mb-2 lg:text-2xl">
            {title}
          </h2>
        </div>
        {!hideAllPromotionButton && (
          <a
            href={PUBLIC_URL + `/dealer-toyota/${baseUrl}`}
            onClick={(e) => handleGoToPromoBranchList(e, data)}
          >
            <div
              id="branch-all-promo-plp"
              className="flex items-center justify-between gap-1 w-[111px] lg:w-[154px]"
            >
              <span className="text-xs font-semibold lg:text-base lg:font-medium gap-[5px] lg:gap-3 leading-relaxed text-reliableBlack">
                LIHAT SEMUA
              </span>
              <FiArrowRight size={20} color="#CE181E" />
            </div>
          </a>
        )}
      </div>
      <p className="text-xs font-medium leading-relaxed text-reliableBlack mb-5 lg:text-base px-4 lg:px-0">
        {description}
      </p>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 md:gap-6">
        {data.map((items, index) => {
          let url = '';
          const citySlug = convertStringToSlug(items.city?.name);
          switch (items.articleType) {
            case 'city':
              url = `${citySlug}/promosi`;
              break;
            case 'branch':
              url = `${citySlug}/${items.branch?.branchLandingPage?.seoSlug}/promosi`;
              break;
            default:
              break;
          }

          return (
            <CardPromo
              key={items.id}
              title={items.titlePage}
              slug={items.slug}
              startDate={items.startDate}
              endDate={items.endDate}
              coverImg={items.heroImageLink}
              altImgText={items.altImage}
              tag={items.tag}
              category={`${url}/${convertStringToSlug(items.contentCategory?.name)}`}
              href={
                !url
                  ? `${PUBLIC_URL}/promosi/${convertStringToSlug(items.contentCategory?.name)}/${items.slug}`
                  : null
              }
              onClickNative={(e) => handleGoToPromoBranchDetail(e, 'goToPromoBranchDetail', items)}
              idPage={''}
              classNames={''}
              index={index}
              pageTitle={pageTitle}
              breadcrumbItems={breadcrumbItems}
              branchProvince={branchProvince}
              city={city}
              cityCode={cityCode}
              feature={feature}
            />
          );
        })}
        {data?.length === 0 && (
          <div className="mt-4 lg:mt-0">
            <p className="text-sm lg:text-base">Promo tidak tersedia.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PromoEventSection;
